import { SCROLL_EDGE_FADE_HEIGHT } from "@-/dev.improve.haniverse.components.ui.scroll-edge-fade";

/**
 * Geometry of the learn summary's floating CTA lane, and the padding the due-review grid must
 * reserve so its last row can always be scrolled clear of the pill.
 *
 * The CTA ("Start Reviewing") is `position: absolute` at `bottom: LEARN_SUMMARY_CTA_BOTTOM_GAP`
 * with height `LEARN_SUMMARY_CTA_HEIGHT`, so its top edge sits the sum of those two from the
 * scroll container's bottom; one more gap keeps the final row off the pill without wasting space.
 *
 * Same shape as Browse's `BROWSE_TABS_CONTENT_BOTTOM_INSET`, and for the same reason: the grid
 * runs the full height of the scene and the pill floats over it, so the clearance belongs on the
 * scroll CONTENT, not on the scene's layout padding —
 * layout padding would shorten the scroll viewport instead of extending its content, and the rows
 * would stop above the pill rather than passing beneath it.
 */

/** Height of the CTA pill (Tailwind `h-11`). */
const LEARN_SUMMARY_CTA_HEIGHT = 44;

/** Visible gap between the floating controls and the top of the bottom tabs. */
export const LEARN_SUMMARY_CTA_BOTTOM_GAP = 9;

/**
 * Bottom padding (px) the due-review grid reserves on its scroll content so the last row clears
 * the floating CTA. Apply as `contentContainerStyle`/`contentContainerClassName` padding.
 *
 * A further `SCROLL_EDGE_FADE_HEIGHT` reserves a band's worth of scrollable buffer, so the final
 * row can be scrolled CLEAR of the fade instead of coming to rest permanently half-dissolved
 * under it — the fade then only ever covers tiles the user can still scroll into view, so "faded"
 * always means "there is more below".
 */
export const LEARN_SUMMARY_CONTENT_BOTTOM_INSET =
  LEARN_SUMMARY_CTA_BOTTOM_GAP +
  LEARN_SUMMARY_CTA_HEIGHT +
  LEARN_SUMMARY_CTA_BOTTOM_GAP +
  SCROLL_EDGE_FADE_HEIGHT;
